import type { IconSvgObject } from './types';

const HandPointingDown01Icon: IconSvgObject = [
  ["path", { d: "M18 1.99998V3.99998L18.9985 6.31079C19.7056 7.78746 20.6732 10.6774 19.3211 12.0382C17.1895 14.1833 14.2082 14.5759 12.5 14.5V20.25C12.5 21.2165 11.7165 22 10.75 22C9.7835 22 9 21.2165 9 20.25L9 9.99998L6.78341 12.3287C6.05938 12.9689 4.96519 12.8628 4.36948 12.0947C3.87385 11.4556 3.87719 10.5465 4.3775 9.91136L9 4.00267V1.99999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingDown01Icon;
